import React from 'react';
import { css } from '@emotion/react';
import Container from '../../primitives/grid/container';
import { useMicrosite } from '../../../contexts/franchise/microsite-context';
import Link from '../../primitives/link';
import { colors } from '../../primitives/colors';
import { useCtaProvider } from '../../../contexts/franchise/cta-provider';
import Typography from '../../primitives/typography';
import { useSiteSearch } from '../../site-search/site-search/provider';
import SearchIcon from './search-icon';

const styles = {
    wrapper: css({
        backgroundColor: colors.primaryOrange,
        overflow: 'hidden',
        position: 'relative',
        color: colors.shadesWhite,
    }),
    containerFlexArea: css({
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: '100%',
        gap: '34px',
        marginLeft: 'auto',
        marginRight: 'auto',
        padding: '5px 0',
    }),
    searchTypography: css({
        display: 'inline-flex',
        gap: '5px',
        alignItems: 'center',
        justifyContent: 'center',
    }),
    text: css({
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'flex-end',
        paddingTop: '16px',
    }),
};

const TopNav = (): JSX.Element|null => {
    const { setVisible } = useSiteSearch();

    const {
        isMicrosite,
    } = useMicrosite();

    const {
        hideNationalCallCenter,
        hideFranchiseLink,
    } = useCtaProvider();

    if (isMicrosite) return null;

    return (
        <>
            <div css={styles.wrapper}>
                <Container>
                    <div css={styles.containerFlexArea}>
                        <Typography
                            as={Link}
                            to="/franchise-ownership"
                            fontSize={{
                                dt: 'base',
                            }}
                            fontWeight="medium"
                        >
                            Own a Franchise
                        </Typography>
                        <Typography
                            fontSize={{
                                dt: 'base',
                            }}
                            fontWeight="medium"
                            as="button"
                            onClick={() => {
                                setVisible(true);
                            }}
                            css={styles.searchTypography}
                        >
                            <SearchIcon />
                            Search
                        </Typography>
                    </div>
                </Container>
            </div>

            <Container>
                <Typography
                    color="primaryOrange"
                    fontSize={{
                        dt: 'lg',
                    }}
                    css={styles.text}
                    dangerouslySetInnerHTML={{
                        __html: (!hideFranchiseLink && !hideNationalCallCenter) ? 'Call Today - 24/7 Emergency Services' : '&nbsp;',
                    }}
                />
            </Container>
        </>
    );
};

export default TopNav;
